import React, { useEffect, useState } from 'react'
import {
  PaymentElement,
  CardElement,
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js'
import { FRONT_URL, STRIPE_URL } from '../../config'
import { toast } from 'react-toastify'
import { CircularProgress, Grid, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/pro-solid-svg-icons'
import lightTheme from '../../styles/theme/lightTheme'

export default function CheckoutFormSubscriptionTest({
  paymentIntentId,
  userId,
  offreId,
  offrePrice,
  type,
  periode,
  onSuccess,
  onClose,
  codePromoObject,
  offreQuantity,
}) {
  const { t, i18n } = useTranslation()
  const stripe = useStripe()
  const elements = useElements()

  const user = useSelector((state) => state.userAuth.user)
  const [isLoading, setIsLoading] = useState(false)

  let user_id = userId //id utilisateur
  let offre_id = offreId //id offre
  let price = offrePrice // prix total a paye

  useEffect(() => {
    if (!stripe) {
      return
    }
  }, [stripe])

  /* const createPaymentMethod = async (paymentMethodId) => {
    try {
      const response = await fetch(`${STRIPE_URL}create_payment_method`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          payment_method_id: paymentMethodId,
          id_client: userId,
          devise: sessionStorage.getItem('currency')
            ? JSON.parse(sessionStorage.getItem('currency')).devise
            : 'CHF',
        }),
      })

      const result = await response.json()
      console.log('Payment method created:', result)
      return result
    } catch (error) {
      console.error('Error creating payment method:', error)
      throw error
    }
  } */

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    // 1. créer paymentMethod
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardNumberElement),
      billing_details: {
        name: user.data.prenom + ' ' + user.data.nom,
        email: user.data.email,
      },
    })

    if (error) {
      console.error(error.message)
      return
    }

    // 1. demander clientSecret au backend
    const res = await fetch(`${STRIPE_URL}create_subscription_intent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        request_type: 'create_subscription_intent',
        id_offre: offre_id,
        id_client: user_id,
        prix: price,
        periode: periode,
        type: type,
        quantity: offreQuantity,
        paymentMethodId: paymentMethod.id,
        devise: sessionStorage.getItem('currency')
          ? JSON.parse(sessionStorage.getItem('currency')).devise
          : 'CHF',
      }),
    })

    const { clientSecret, subscriptionId } = await res.json()

    // 2. confirmer paiement
    const result = await stripe.confirmCardPayment(clientSecret)

    if (result.error) {
      console.error(result.error.message)
    } else {
      if (result.paymentIntent.status === 'succeeded') {
        // Publiez les informations de transaction sur le script côté serveur et redirigez vers la page d'état du paiement
        fetch(`${STRIPE_URL}` + 'subscription_payment_insert', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            request_type: 'subscription_payment_insert',
            payment_intent: result.paymentIntent.id,
            paymentMethodId: paymentMethod.id,
            periode: periode,
            id_offre: offre_id,
            id_client: user_id,
            quantity: offreQuantity,
            subscriptionId: subscriptionId,
            prix: price,
            type: 'subscription',
            devise: sessionStorage.getItem('currency')
              ? JSON.parse(sessionStorage.getItem('currency')).devise
              : 'CHF',
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            data = JSON.parse(data)
            if (data.payment_id && data.payment_status === 'succeeded') {
              toast.success(t('successMessage.paymentOk'), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
                icon: ({ theme, type }) => (
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    fontSize={25}
                    color={lightTheme.palette.success.main}
                  />
                ),
              })
              //setMessage(t('successMessage.paymentOk'))
              setIsLoading(false)
              setTimeout(() => {
                onSuccess()
              }, 1000)
            } else {
              toast.error(t('successMessage.paymentNok'), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
                icon: ({ theme, type }) => (
                  <FontAwesomeIcon
                    icon={faCircleExclamation}
                    fontSize={25}
                    color={lightTheme.palette.error.main}
                  />
                ),
              })
              //setMessage(t('successMessage.paymentNok'))
              setIsLoading(false)
              setTimeout(() => {
                onClose()
              }, 1000)
            }
          })
          .catch(console.error)
      }
    }
  }

  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <label>{t('payment.cardNumber')}</label>
            <Box
              sx={{
                my: 1,
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              }}
            >
              <CardNumberElement
                showIcon={true}
                options={{
                  showIcon: true,
                  style: {
                    base: {
                      fontSize: '16px',
                      color: '#424770',
                      '::placeholder': {
                        color: '#aab7c4',
                      },
                      iconColor: '#635bff',
                    },
                    invalid: {
                      color: '#9e2148',
                      iconColor: '#9e2148',
                    },
                  },
                  hidePostalCode: true,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <label>{t('payment.expiry')}</label>
            <Box
              sx={{
                my: 1,
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              }}
            >
              <CardExpiryElement
                showIcon={true}
                options={{
                  showIcon: true,
                  style: {
                    base: {
                      fontSize: '16px',
                      color: '#424770',
                      '::placeholder': {
                        color: '#aab7c4',
                      },
                      iconColor: '#635bff',
                    },
                    invalid: {
                      color: '#9e2148',
                      iconColor: '#9e2148',
                    },
                  },
                  hidePostalCode: true,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <label>{t('payment.cvc')}</label>
            <Box
              sx={{
                my: 1,
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              }}
            >
              <CardCvcElement
                showIcon={true}
                options={{
                  showIcon: true,
                  style: {
                    base: {
                      fontSize: '16px',
                      color: '#424770',
                      '::placeholder': {
                        color: '#aab7c4',
                      },
                      iconColor: '#635bff',
                    },
                    invalid: {
                      color: '#9e2148',
                      iconColor: '#9e2148',
                    },
                  },
                  hidePostalCode: true,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="#6d6e78" sx={{ mb: 2 }}>
              {t('payment.authorization')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {/* <PaymentElement id="payment-element" /> */}

            <button
              disabled={isLoading || !stripe || !elements}
              id="submit"
              style={{
                width: '100%',
                padding: '12px 24px',
                backgroundColor: '#96A0FF',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor:
                  isLoading || !stripe || !elements ? 'not-allowed' : 'pointer',
                opacity: isLoading || !stripe || !elements ? 0.7 : 1,
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                if (!isLoading && stripe && elements) {
                  e.target.style.backgroundColor = '#808BF8'
                }
              }}
              onMouseLeave={(e) => {
                if (!isLoading && stripe && elements) {
                  e.target.style.backgroundColor = '#96A0FF'
                }
              }}
            >
              {isLoading ? <CircularProgress size={20} color='inherit' /> : t('button.subscribe')}
            </button>

            {/* Afficher les messages d'erreur ou de réussite */}
            {/* {message && <div id="payment-message">{message}</div>} */}
          </Grid>
        </Grid>
      </form>
    </>
  )
}
